import { render, staticRenderFns } from "./k-no-content.vue?vue&type=template&id=5d5c0213&scoped=true&"
import script from "./k-no-content.vue?vue&type=script&lang=ts&"
export * from "./k-no-content.vue?vue&type=script&lang=ts&"
import style0 from "./k-no-content.vue?vue&type=style&index=0&id=5d5c0213&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c0213",
  null
  
)

export default component.exports